import React from "react";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/pro-solid-svg-icons";

import SectionCard from "../SectionCard";
import SubSection from "../SubSection";
import AppointmentInfo from "./components/AppointmentInfo";
import CommunicationEvents from "./components/CommunicationEvents";
import Services from "./components/Services";
import Agreements from "./components/Agreements";
import Signature from "./components/Signature";
import { ANSWERS } from "../../../../util/answers";
import { DESK_COMMUNICATION_EVENTS } from "../../../../util/communication_statuses";

import "./index.scss";

const getLastCommunication = communications =>
  communications?.reduce((lastCommunication, current) =>
    (current.created_on || "").localeCompare(lastCommunication.created_on || "") > 0 ? current : lastCommunication
  );

const hasSignature = comm => comm?.events?.some(e => e.type === DESK_COMMUNICATION_EVENTS.CHECKIN_ANSWERED && e.customer_signature);

const renderCommSection = ({ comm, appointment, dealerLocation, isCheckout, t }) => {
  const agreedExtra = comm.results?.filter(r => r.status === ANSWERS.ADD_TO_CART) || [];
  const declinedExtra = comm.results?.filter(r => r.status === ANSWERS.NOT_OK) || [];

  const title = isCheckout
    ? t("cc_desk_check_out_communication_log").message || "Desk Check-out Communication Log"
    : t("cc_desk_check_in_communication_log").message || "Desk Check-in Communication Log";

  return (
    <SectionCard key={comm.id} title={title} icon={<FontAwesomeIcon icon={faList} />} onContentBorder>
      <SubSection title={t("cc_appointment_information").message || "Appointment Information"}>
        <AppointmentInfo appointment={appointment} t={t} />
      </SubSection>

      {comm.events?.length > 0 && (
        <SubSection title={t("cc_communication_events").message || "Communication events"}>
          <CommunicationEvents events={comm.events} comm={comm} t={t} />
        </SubSection>
      )}

      {comm.agreed_interventions?.length > 0 && (
        <SubSection title={t("cc_accepted_scheduled_services").message || "Accepted scheduled services"}>
          <Services services={comm.agreed_interventions} dealerLocation={dealerLocation} t={t} />
        </SubSection>
      )}

      {agreedExtra.length > 0 && (
        <SubSection title={t("cc_accepted_extra_services").message || "Accepted extra services"}>
          <Services services={agreedExtra} dealerLocation={dealerLocation} t={t} />
        </SubSection>
      )}

      {comm.declined_interventions?.length > 0 && (
        <SubSection title={t("cc_declined_scheduled_services").message || "Declined scheduled services"}>
          <Services services={comm.declined_interventions} dealerLocation={dealerLocation} t={t} />
        </SubSection>
      )}

      {declinedExtra.length > 0 && (
        <SubSection title={t("cc_declined_extra_services").message || "Declined extra services"}>
          <Services services={declinedExtra} dealerLocation={dealerLocation} t={t} />
        </SubSection>
      )}

      {comm.agreements?.length > 0 && (
        <SubSection title={t("cc_agreements").message || "Agreements"}>
          <Agreements agreements={comm.agreements} />
        </SubSection>
      )}

      {hasSignature(comm) && (
        <SubSection title={t("cc_signature").message || "Signature"}>
          <Signature events={comm.events} />
        </SubSection>
      )}
    </SectionCard>
  );
};

const DeskCommunicationLog = ({ appointment, t }) => {
  const lastCommunication = getLastCommunication(appointment.desk_communications);
  if (!lastCommunication) return null;

  const dealerLocation = appointment.dealer_location;

  return (
    <div className="desk-communication-log">
      {renderCommSection({ comm: lastCommunication, appointment, dealerLocation, isCheckout: Boolean(lastCommunication.is_checking_out), t })}
    </div>
  );
};

export default withTranslation()(DeskCommunicationLog);
